var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { alpha } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { ChevronDown } from 'react-feather';
import { menuItem, paper } from '../../css';
export function autocomplete(theme) {
    var _a, _b, _c;
    var isXs = globalThis.window !== undefined && globalThis.window.innerWidth <= 600;
    return {
        MuiAutocomplete: {
            defaultProps: {
                popupIcon: _jsx(ChevronDown, { size: 18 }),
                slotProps: { chip: { size: 'small', variant: 'soft' } }
            },
            styleOverrides: {
                root: (_a = {},
                    _a["& span.".concat(autocompleteClasses.tag)] = __assign(__assign({}, theme.typography.subtitle2), { height: 24, minWidth: 24, lineHeight: '24px', textAlign: 'center', padding: theme.spacing(0, 0.75), color: theme.palette.text.secondary, borderRadius: theme.shape.borderRadius, backgroundColor: alpha(theme.palette.grey[500], 0.16) }),
                    _a["& .".concat(autocompleteClasses.tag, " .MuiChip-label")] = {
                        maxWidth: '80px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1)
                    },
                    _a["& .MuiAutocomplete-inputRoot .MuiAutocomplete-input"] = {
                        width: 0,
                        minWidth: '0px'
                    },
                    _a),
                paper: __assign(__assign({}, paper({ theme: theme, dropdown: true })), { maxHeight: isXs ? 100 : 200, overflowY: 'auto' }),
                listbox: (_b = {
                        padding: 0,
                        maxHeight: '100%',
                        overflowY: 'unset'
                    },
                    _b["& .".concat(autocompleteClasses.option)] = __assign({}, menuItem(theme)),
                    _b),
                endAdornment: (_c = {},
                    _c["& .".concat(svgIconClasses.root)] = {
                        width: 18,
                        height: 18
                    },
                    _c)
            }
        }
    };
}
